/**
 * Flooded / Blue-Orange-Red.
 */ var BlueOrangeRed = [
    /**
     * Red Props.
     */ {
        variant: 'red',
        size: '1121',
        rotate: -130,
        blur: 21.3,
        x: '56',
        y: '-676'
    },
    /**
     * Orange Props.
     */ {
        variant: 'orange',
        size: '971',
        rotate: 50,
        blur: 19.3,
        x: '-573',
        y: '-44'
    },
    /**
     * Blue Props.
     */ {
        variant: 'blue',
        size: '968',
        rotate: 50,
        blur: 21.3,
        x: '779',
        y: '540'
    },
    /**
     * Green Props.
     */ {
        variant: 'green',
        size: '968',
        rotate: 130,
        blur: 21.3,
        x: '-215',
        y: '833'
    }
];

export { BlueOrangeRed as default };
//# sourceMappingURL=blue-orange-red.es.js.map
